import {
  IconBrandDiscord,
  IconBrandInstagram,
  IconBrandLinkedin,
  IconBrandPinterest,
  IconBrandTiktok,
} from "@tabler/icons-react";

const SocialIcon = ({
  name,
  size = 18,
  stroke = 1.8,
}: {
  name: string;
  size?: number;
  stroke?: number;
}) => {
  const props = { size, stroke, "aria-hidden": true } as const;

  switch (name.toUpperCase()) {
    case "INSTAGRAM":
      return <IconBrandInstagram {...props} />;
    case "DISCORD":
      return <IconBrandDiscord {...props} />;
    case "PINTEREST":
      return <IconBrandPinterest {...props} />;
    case "LINKEDIN":
      return <IconBrandLinkedin {...props} />;
    case "TIK TOK":
    case "TIKTOK":
      return <IconBrandTiktok {...props} />;
    default:
      return null;
  }
};

export default SocialIcon;
